import React from 'react'
import { WhatsAppContext, WhatsAppContextProps } from 'components/WhatsAppButton/WhatsAppContext'
import { Footer, RootBackgroundImage } from 'components/index'

export interface LandingPageLayoutProps {
  children?: React.ReactNode
  whatsAppContextValue?: WhatsAppContextProps
}

export const LandingPageLayout = ({ children, whatsAppContextValue = {} }: LandingPageLayoutProps) => {
  return (
    <WhatsAppContext.Provider value={whatsAppContextValue}>
      <RootBackgroundImage>
        <div className=''>{children}</div>
        <Footer />
      </RootBackgroundImage>
    </WhatsAppContext.Provider>
  )
}

export default LandingPageLayout
